import { styled as muiStyled, css } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import React from 'react';

import Arranger from '../../base/arranger';

import { getDesignTokens } from '~c/components/base/core';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
  onClearFilters?: () => void;
}

const FilterHeaderImpl: React.FC<Props> = ({ className }) => {
  return (
    <Arranger
      className={className}
      justify="space-between"
      alignItems="center"
      sx={{ px: spc.container_padding_m }}
    >
      <Text sz="title" noWrap sx={{ mb: spc.xxs }}>
        FILTERS
      </Text>
    </Arranger>
  );
};

export const FilterHeader = muiStyled(FilterHeaderImpl)(({
  theme,
}: {
  theme: Theme;
}) => {
  const t = getDesignTokens(
    theme.palette.mode === 'dark' ? 'dark' : 'light',
    theme.accentPalette
  );
  const nav = t.nav;
  return css`
    /* Sidebar is always dark; use nav tokens so label is visible in light and dark app mode */
    .MuiTypography-root {
      color: var(--org-primary-contrast, ${nav.itemTextOnDarkMuted});
    }
  `;
});

export default FilterHeader;
